<template>
  <div class="mobile-step2">
    <van-field
      v-model="device.sn"
      name="sn"
      label="序列号"
      placeholder="请输入序列号"
      :rules="[{ required: true, message: '序列号不能为空' }]"
      required
    >
      <!-- <template #right-icon>
        <van-icon name="scan" @click="startScan" class="scan-icon" />
      </template> -->
    </van-field>
    <div class="field-tip red">
      注：序列号为8-14位数字和字母，可在机器系统设置/机器后壳/保修卡上查询
    </div>

    <van-field
      v-model="device.powerOnPass"
      name="powerOnPass"
      label="开机密码"
      placeholder="如有开机密码一定需要填写，没有可不填"
    />

    <van-cell
      title="购买日期"
      is-link
      @click="showDatePicker = true"
      :value="device.purTime ? formatDate(device.purTime) : '请选择日期'"
      required
    />
    <div class="field-tip red">保修期内产品需上传购买凭证</div>

    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :max-date="maxDate"
        @confirm="selectDate"
        @cancel="showDatePicker = false"
      />
    </van-popup>

    <div v-if="showPurchases || device.purchases.length">
      <van-cell title="购买凭证" />
      <div class="upload-content">
        <van-uploader
          v-model="purchaseFiles"
          :before-read="beforeReadPurchase"
          :after-read="afterReadPurchase"
          accept=".jpeg, .jpg, .png, .bmp, image/*"
          @delete="removePurchase"
        />
        <div v-if="uploadStartPurchase" class="upload-progress">
          <van-progress :percentage="percentage" />
        </div>
      </div>
    </div>

    <van-cell-group title="故障问题">
      <van-field
        v-model="device.desc"
        name="desc"
        label="故障描述"
        type="textarea"
        rows="4"
        placeholder="请填写故障相关描述"
        :rules="[{ required: true, message: '故障描述不能为空' }]"
        required
      />
    </van-cell-group>

    <div class="upload-section">
      <van-cell title="附件上传" required />
      <div class="upload-content">
        <div class="upload-tip">
          请将阅读器的外观（包括正面屏幕以及背面后壳）及问题描述的清晰图片或视频，进行拍照上传
        </div>
        <van-uploader
          v-model="attachFiles"
          :before-read="beforeReadAttach"
          :after-read="afterReadAttach"
          accept=".jpeg, .jpg, .png, .bmp, image/*, video/*"
          @delete="removeAttach"
        />
        <div v-if="uploadStartAttach" class="upload-progress">
          <van-progress :percentage="percentage" />
        </div>
      </div>
    </div>

    <div class="service-info">
      <div class="service-title">此问题或许可以通过联系在线客服得到解决</div>
      <div class="service-contact">
        <div>
          <p>联系人：文石售后维修</p>
          <p>电话：4008-860-830</p>
        </div>
        <div class="service-qr">
          <img src="@/assets/imgs/onlineCustomerService.png" alt="客服二维码" />
        </div>
      </div>
    </div>

    <!-- 图片预览器 -->
    <van-image-preview v-model="showPreview" :images="previewImages" />

    <!-- 视频播放器 -->
    <van-popup
      v-model="showVideo"
      round
      closeable
      close-icon="close"
      @click-close-icon="closeVideo"
      style="width: 90%; height: 50%"
    >
      <video controls @click.stop class="video-player" v-if="videoSrc">
        <source :src="videoSrc" />
      </video>
    </van-popup>
  </div>
</template>

<script>
// 声明全局 OSS 对象
/* global OSS */
// 声明微信小程序全局对象
/* global wx */

export default {
  props: {
    device: {
      type: Object,
    },
    params: {
      type: Object,
    },
  },
  data() {
    return {
      showDatePicker: false,
      currentDate: new Date(),
      maxDate: new Date(),
      showPurchases: false,
      percentage: 0,
      uploadStartPurchase: false,
      uploadStartAttach: false,
      ossClient: null,
      purchaseFiles: [],
      attachFiles: [],
      showPreview: false,
      previewImages: [],
      showVideo: false,
      videoSrc: "",
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },

    selectDate(date) {
      this.device.purTime = date;
      this.showDatePicker = false;
      this.getPurTime();
    },

    getPurTime() {
      let start = new Date(this.device.purTime).getTime();
      let end = new Date().getTime();
      var day = parseInt((end - start) / (24 * 60 * 60 * 1000));
      if (day <= 365) {
        this.showPurchases = true;
      } else {
        this.device.purchases = [];
        this.showPurchases = false;
      }
    },

    goBack() {
      this.$emit("goBack");
    },

    submitForm() {
      if (this.showPurchases && !this.device.purchases.length) {
        this.$toast("请上传购买凭证");
        return;
      }

      if (!this.params.attachs.length) {
        this.$toast("请上传附件");
        return;
      }

      this.$emit("nextPage");
    },

    // 文件上传前检查
    beforeReadPurchase(file) {
      // 检查文件类型
      const acceptTypes = ["image/jpeg", "image/jpg", "image/png", "image/bmp"];
      if (!acceptTypes.includes(file.type)) {
        this.$toast("请上传正确格式的图片");
        return false;
      }

      // 检查文件大小
      if (file.size > 200 * 1024 * 1024) {
        this.$toast("文件大小不能超过200MB");
        return false;
      }
      return true;
    },

    beforeReadAttach(file) {
      // 检查文件大小
      if (file.size > 200 * 1024 * 1024) {
        this.$toast("文件大小不能超过200MB");
        return false;
      }
      return true;
    },

    // 文件上传
    async afterReadPurchase(file) {
      this.uploadStartPurchase = true;
      this.ossClient = await this.getOssClient();
      try {
        let params = {
          size: file.file.size,
          name: file.file.name,
          format: file.file.name.split(".").pop(),
          path: `attachments/${this.uuid()}${new Date().getTime()}.${file.file.name
            .split(".")
            .pop()}`,
          desc: "",
        };

        await this.ossClient.multipartUpload(params.path, file.file, {
          progress: (p) => {
            let progress = parseInt(p.toFixed(2) * 100);
            this.percentage = progress;
          },
        });

        this.uploadStartPurchase = false;
        this.percentage = 0;
        this.device.purchases.push(params);
      } catch (error) {
        this.uploadStartPurchase = false;
        this.percentage = 0;
        this.$toast.fail("上传失败");
        console.error(error);
      }
    },

    async afterReadAttach(file) {
      this.uploadStartAttach = true;
      this.ossClient = await this.getOssClient();
      try {
        let params = {
          size: file.file.size,
          name: file.file.name,
          format: file.file.name.split(".").pop(),
          path: `attachments/${this.uuid()}${new Date().getTime()}.${file.file.name
            .split(".")
            .pop()}`,
          desc: "",
        };

        await this.ossClient.multipartUpload(params.path, file.file, {
          progress: (p) => {
            let progress = parseInt(p.toFixed(2) * 100);
            this.percentage = progress;
          },
        });

        this.uploadStartAttach = false;
        this.percentage = 0;
        this.params.attachs.push(params);
      } catch (error) {
        this.uploadStartAttach = false;
        this.percentage = 0;
        this.$toast.fail("上传失败");
        console.error(error);
      }
    },

    async getOssClient() {
      try {
        let res = await this.$http.getSts();
        let region = "oss-cn-shenzhen";
        let bucket = "onyx-work-order";
        let client = new OSS({
          region,
          bucket,
          accessKeyId: res.data.accessKeyId,
          accessKeySecret: res.data.accessKeySecret,
          stsToken: res.data.securityToken,
        });
        return client;
      } catch (error) {
        throw new Error(error);
      }
    },

    uuid() {
      return `${this.s4()}${this.s4()}${this.s4()}${this.s4()}${this.s4()}${this.s4()}${this.s4()}${this.s4()}`;
    },

    s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    },

    // 预览文件
    async previewFile(file) {
      if (!file.url) {
        let ossClient = await this.getOssClient();
        file.url = ossClient.signatureUrl(file.path, { expires: 3600 });
      }

      if (["jpeg", "jpg", "png", "bmp"].includes(file.format)) {
        this.previewImages = [file.url];
        this.showPreview = true;
      } else {
        this.videoSrc = file.url;
        this.showVideo = true;
      }
    },

    closeVideo() {
      this.showVideo = false;
      this.videoSrc = "";
    },

    // 删除购买凭证
    removePurchase(file) {
      // 尝试通过多种方式匹配文件
      const fileIndex = this.device.purchases.findIndex((item) => {
        // 通过url或path匹配
        if (
          (file.url && item.url === file.url) ||
          (file.path && item.path === file.path)
        ) {
          return true;
        }
        // 通过文件名匹配
        if (file.name && item.name === file.name) {
          return true;
        }
        // 通过content匹配（Vant上传组件可能使用content属性）
        if (file.content && item.path === file.content) {
          return true;
        }
        return false;
      });

      if (fileIndex > -1) {
        this.device.purchases.splice(fileIndex, 1);
      }
    },

    // 删除附件
    removeAttach(file) {
      // 尝试通过多种方式匹配文件
      const fileIndex = this.params.attachs.findIndex((item) => {
        // 通过url或path匹配
        if (
          (file.url && item.url === file.url) ||
          (file.path && item.path === file.path)
        ) {
          return true;
        }
        // 通过文件名匹配
        if (file.name && item.name === file.name) {
          return true;
        }
        // 通过content匹配（Vant上传组件可能使用content属性）
        if (file.content && item.path === file.content) {
          return true;
        }
        return false;
      });

      if (fileIndex > -1) {
        this.params.attachs.splice(fileIndex, 1);
      }
    },

    // 将URL转为base64
    urlToBase64(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous"; // 处理跨域问题
        img.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL("image/jpeg");
            resolve(dataURL);
          } catch (error) {
            console.error("转换图片失败:", error);
            reject(error);
          }
        };
        img.onerror = (error) => {
          console.error("加载图片失败:", error);
          reject(error);
        };
        img.src = url;
      });
    },

    // 初始化购买凭证文件
    async initPurchaseFiles() {
      if (this.device.purchases && this.device.purchases.length) {
        // 获取 OSS 客户端
        this.ossClient = await this.getOssClient();

        // 为每个文件生成签名 URL
        this.purchaseFiles = await Promise.all(
          this.device.purchases.map(async (item) => {
            if (item.content) {
              return {
                ...item,
                content: item.content,
                url: item.content,
                isImage: ["jpeg", "jpg", "png", "bmp"].includes(item.format),
              };
            } else {
              const url = this.ossClient.signatureUrl(item.path, {
                expires: 3600,
              });
              try {
                const base64Data = await this.urlToBase64(url);

                return {
                  ...item,
                  content: base64Data,
                  url: url,
                  isImage: ["jpeg", "jpg", "png", "bmp"].includes(item.format),
                };
              } catch (error) {
                return {
                  ...item,
                  content: item.path,
                  url: url,
                  isImage: ["jpeg", "jpg", "png", "bmp"].includes(item.format),
                };
              }
            }
          })
        );
      }
    },

    // 初始化附件文件
    async initAttachFiles() {
      if (this.params.attachs && this.params.attachs.length) {
        try {
          // 获取 OSS 客户端
          this.ossClient = await this.getOssClient();

          // 为每个文件生成签名 URL
          this.attachFiles = await Promise.all(
            this.params.attachs.map(async (item) => {
              // 如果有content（base64数据），直接使用
              if (item.content) {
                return {
                  ...item,
                  content: item.content,
                  url: item.content,
                  isImage: ["jpeg", "jpg", "png", "bmp"].includes(item.format),
                };
              } else {
                const url = this.ossClient.signatureUrl(item.path, {
                  expires: 3600,
                });
                const isImage = ["jpeg", "jpg", "png", "bmp"].includes(
                  item.format
                );
                if (isImage) {
                  try {
                    const base64Data = await this.urlToBase64(url);
                    return {
                      ...item,
                      content: base64Data,
                      url: url,
                      isImage: true,
                    };
                  } catch (error) {
                    console.error("转换图片失败:", error);
                  }
                }

                // 如果不是图片或转换失败，使用原URL
                return {
                  ...item,
                  content: item.path,
                  url: url,
                  isImage: isImage,
                };
              }
            })
          );
        } catch (error) {
          console.error("初始化附件文件失败:", error);
        }
      }
    },

    startScan() {
      if (typeof wx !== "undefined") {
        this.$emit("saveData");
        wx.miniProgram.redirectTo({
          url: `/pages/scan/scan?from=${encodeURIComponent(location.href)}`,
        });
      } else {
        // 没有wx对象，可能是在普通浏览器中
        this.$toast("当前环境不支持扫码功能");
      }
    },
  },
  mounted() {
    // 转换购买日期为日期对象
    if (this.device.purTime) {
      this.currentDate = new Date(this.device.purTime);
    }

    this.getPurTime();

    // 初始化文件显示（改为异步调用）
    this.initPurchaseFiles().catch((err) =>
      console.error("初始化购买凭证失败:", err)
    );
    this.initAttachFiles().catch((err) =>
      console.error("初始化附件失败:", err)
    );
  },

  // 添加对 props 的监听
  watch: {
    "device.purchases": {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.initPurchaseFiles().catch((err) =>
            console.error("监听变化初始化购买凭证失败:", err)
          );
        }
      },
      deep: true,
    },
    "params.attachs": {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.initAttachFiles().catch((err) =>
            console.error("监听变化初始化附件失败:", err)
          );
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-step2 {
  background-color: #f7f8fa;

  .field-tip {
    padding: 0 16px;
    font-size: 12px;
    color: #969799;
    background-color: #fff;

    &.red {
      color: #f44;
    }
  }

  .mt10 {
    margin-top: 10px;
  }

  .upload-content {
    padding: 10px 16px;
    background-color: #fff;

    .upload-tip {
      margin-bottom: 10px;
      font-size: 12px;
      color: #969799;
    }

    .upload-progress {
      margin-top: 10px;
    }
  }

  .service-info {
    padding: 16px;
    margin: 10px 10px 0;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

    .service-title {
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: bold;
    }

    .service-contact {
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        margin: 5px 0;
        font-size: 13px;
      }

      .service-qr {
        width: 90px;
        height: 90px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .video-player {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

::v-deep .van-field__control {
  text-align: right;
}

::v-deep .van-field--textarea .van-field__control {
  text-align: left;
}

.scan-icon {
  font-size: 20px;
  color: #000;
  font-weight: bold;
  cursor: pointer;
}
</style>
